import React from 'react';
import { SocialLinks } from './SocialLinks';
import './SocialLinks.css';
import './Footer.css';

const FOOTER_LINKS = [
  { href: '/about', label: 'About' },
  { href: '/learn', label: 'Learn about Synesthesia' },
  { href: 'https://synesthetic.ca/blog', label: 'Blog' },
  { href: 'https://synesthetic.ca/synesthesia-glossary', label: 'Synesthesia Glossary' },
  { href: 'https://forms.gle/NhVErsQGU6WxKMzK8', label: 'Feedback', external: true },
  { href: '/terms', label: 'Terms of Use' },
  { href: '/privacy-policy', label: 'Privacy Policy' },
];

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <SocialLinks className="footer-social" />
        <div className="footer-bottom">
          <p className="footer-copyright">© 2026 Synesthetic.ca. All rights reserved</p>
          <nav className="footer-nav" aria-label="Footer">
            {FOOTER_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="footer-link"
                {...(link.external
                  ? { target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};
